import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Layout, Home, Result, GameDetail } from './pages';
import './App.css'


const App = () => {
  // const [games, setGames] = useState(gameData);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="popular" element={<Result category='popular'/>} />
          <Route path="recent" element={<Result category='recent'/>} />
          <Route path="best" element={<Result category='best'/>} />
          <Route path="platform/:platform" element={<Result category='platform'/>} />
          <Route path="search" element={<Result category='search'/>} />
          <Route path="game/:id" element={<GameDetail/>} />
        </Route>
      </Routes>
    </BrowserRouter>
    
   
  )
}

export default App